import React, { Component } from 'react';
import * as axios from 'axios';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';

import './style.css';

let people_text = 'человек';

class Form extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sertificate: '',
            name: '',
            phone: '',
            date: '',
            page: '',
            email: '',
            count: 1,
            active: false,
            price: null,
            mailSent: false,
            request_send: false,
            error: null,
            is_no_place: false
        }

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this._update_component = this._update_component.bind(this);
    }

    /**
     * Операции:
     * 1) Эффект fadeIn для модального окна;
     * 2) Отправляем в данные компонента значения адрессной строки;
     * 3) Отправляем в данные компонента значения календаря (если там всего одно значение).
     */
    componentDidMount() {
        if (this.props.product_name !== (undefined && null) && this.state.page === '') {
            this.setState({
                page: window.location.href
            })
        }
        if (this.props.calendar.length === 1) {
            this.setState({
                date: this.props.calendar[0]
            })
        }

        if (this.props.date !== undefined) {
            this.setState({
                date: this.props.date
            })
        }
    }

    /**
     * Операции:
     * 1) Обработка текстовой переменной "человек" для правильного окончания;
     * 2) Обработка цены для передачи в state для последующего умножения.
     */
    componentDidUpdate(prevProps, prevState) {
        if (this.state.name !== '' && this.state.phone !== '' && this.state.email !== '' && this.state.phone !== '+375 (__) ___-__-__' && this.state.active === false) {
            this.setState({
                active: true
            })
        } else if ((this.state.name === '' || this.state.phone === '' || this.state.email === '' || this.state.phone === '+375 (__) ___-__-__') && this.state.active === true) {
            this.setState({
                active: false
            })
        }

        if (prevState.count !== this.state.count) {
            let people_count_text = this.state.count+'';
            people_count_text = people_count_text.split('');
            people_count_text = +people_count_text[people_count_text.length-1];
            if (people_count_text > 1 && people_count_text < 5 && +this.state.count !== 11 && +this.state.count !== 12 && +this.state.count !== 13 && +this.state.count !== 14) people_text = "человека"
            else people_text = "человек";
            this.forceUpdate();
        }

        if (this.props.price !== undefined && this.props.price !== null && this.props.price !== '' && this.state.price === null) {
            let temp_price_arr = this.props.price.split(' ');
            if (isFinite(+temp_price_arr[0])) {
                this.setState({
                    price: +temp_price_arr[0]
                })
            }
        }
    }

    /**
     * Функция отправки данных.
     * @param {Element} e элемент, к которому применяется функция
     */
    handleFormSubmit(e) {
        e.preventDefault();
        axios({
            method: 'post',
            url: `${this.props.url+'php/callback-product.php'}`,
            headers: { 'content-type': 'application/json' },
            data: this.state
        })
        .then(result => {
            e.target.reset();
            this.setState({
                mailSent: result
            })
        })
        .catch(error => this.setState({ error: error.message }));
        this.setState({
            request_send: true
        })
    };

    _update_component(e) {
        if (e.target.value.includes(' (мест нет)') && this.state.is_no_place === false) {
            this.setState({
                is_no_place: true
            })
        } else if (this.state.is_no_place === true) {
            this.setState({
                is_no_place: false
            })
        }
    }

    render() {
        return(
            <div className="form-container">
                <p className="form-header">Записаться на мастер-класс</p>
                {
                    this.state.request_send === true ?
                    <p className="form__success-text">
                        Заявка отправлена!<br/>
                        Мы свяжемся с вами!
                    </p>    :
                    this.state.is_no_place === false ?
                    <form className="form" action="#">
                        {/* <input className="form__input-field-sertificate" type="text" name="name" placeholder="Номер сертификата, если есть" onChange={e => this.setState({ sertificate: e.target.value })} /> */}
                        {
                            this.props.calendar.length === 0 ?
                            null :
                            <select className="form__input-field" onBlur={e => this.setState({ date: e.target.selectedOptions[0].label})}
                            onChange={e => this._update_component(e) }>
                                {
                                    this.props.calendar.map((item, index) => {
                                        if (this.props.date !== undefined && this.props.date === item) {
                                            return(
                                                <option key={index}>{item}</option>
                                            )
                                        } else {
                                            return(
                                                <option key={index}>{item}</option>
                                            )
                                        }
                                    })
                                }
                            </select>
                        }
                        <input className="form__input-field" type="text" name="name" placeholder="Имя" onChange={e => this.setState({ name: e.target.value })} />
                        <input className="form__input-field" type="text" name="email" placeholder="Эл. почта" onChange={e => this.setState({ email: e.target.value })} />
                        <InputMask
                            mask="+375\ (99) 999-99-99" maskChar="_"
                            className="form__input-field"
                            type="tel"
                            name="phone"
                            placeholder="Номер телефона"
                            onChange={e => this.setState({ phone: e.target.value })} 
                        />
                        <div className="fl-b__inline">
                            <input className="form__input-field-count" type="text" name="name" placeholder="0" value={this.state.count} onChange={e => this.setState({ count: e.target.value })} maxLength='2' /> {people_text}
                        </div>
                        <button className={this.state.active === true ? "form__btn-submit" : "form__btn-submit form__btn-submit_disabled"} type="submit" onClick={e => this.handleFormSubmit(e)}
                        disabled={this.state.active === true ? false : true}>
                            Записаться{this.state.date !== '' ? " на "+this.state.date : ''}{this.state.count !== '' ? ", "+this.state.count+" "+people_text : this.props.price !== '' ? this.props.count : ''}{this.state.price !== null ? ', '+this.state.count*this.state.price+' р.' : this.props.price !== '' ? ', '+this.props.price : ''}
                        </button>
                    </form> :
                    <form className="form" action="#">
                        {/* <input className="form__input-field-sertificate" type="text" name="name" placeholder="Номер сертификата, если есть" onChange={e => this.setState({ sertificate: e.target.value })} /> */}
                        {
                            this.props.calendar.length === 0 ?
                            null :
                            <select className="form__input-field form__input-field_alone" onBlur={e => this.setState({ date: e.target.selectedOptions[0].label})}
                            onChange={e => this._update_component(e) }>
                                {
                                    this.props.calendar.map((item, index) => {
                                        if (this.props.date !== undefined && this.props.date === item) {
                                            return(
                                                <option key={index}>{item}</option>
                                            )
                                        } else {
                                            return(
                                                <option key={index}>{item}</option>
                                            )
                                        }
                                    })
                                }
                            </select>
                        }
                    </form>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    url: state.site_options.SITE_URL
})

export default connect(mapStateToProps)(Form);